import { render } from "./GenogramLegendView.vue?vue&type=template&id=450cd24b"
import script from "./GenogramLegendView.vue?vue&type=script&lang=js"
export * from "./GenogramLegendView.vue?vue&type=script&lang=js"

import "./GenogramLegendView.vue?vue&type=style&index=0&id=450cd24b&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__